import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaRegHeart } from "react-icons/fa";
import { RiShoppingCartLine } from "react-icons/ri";
import Rating from "../Rating";
import { useDispatch, useSelector } from "react-redux";
import {
  get_wishlist_products,
  remove_wishlist,
  messageClear,
} from "../../store/reducers/cardReducer";
import toast from "react-hot-toast";
import CurrencyFormat from "../shared/CurrencyFormat";

const Wishlist = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { wishlist, successMessage } = useSelector((state) => state.card);

  useEffect(() => {
    dispatch(get_wishlist_products(userInfo.id));
  }, [dispatch, userInfo.id]);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
  }, [successMessage, dispatch]);

  // Agrupa los productos en arrays de 3 para el diseño
  const groupedWishlist = wishlist.reduce((acc, item, index) => {
    const groupIndex = Math.floor(index / 3);
    if (!acc[groupIndex]) acc[groupIndex] = [];
    acc[groupIndex].push(item);
    return acc;
  }, []);

  return (
    <div className="w-full px-4 py-6">
      <div className="flex flex-col gap-6">
        <div className="flex justify-between items-center">
          <div className="text-xl font-bold text-slate-600">
            Mi Lista de Deseos
          </div>
        </div>

        {wishlist.length === 0 ? (
          <div className="text-center text-gray-600 py-8">
            <h2 className="text-xl font-semibold">
              Tu Lista de Deseos está vacía
            </h2>
            <p className="mt-2 text-sm">
              ¡Explora productos y agrégalos a tu lista!
            </p>
          </div>
        ) : (
          <div className="relative overflow-hidden">
            <div className="flex flex-col gap-4">
              {groupedWishlist.map((group, groupIndex) => (
                <div
                  key={groupIndex}
                  className="w-full flex-shrink-0 flex flex-col gap-4 px-4 py-2 bg-white rounded-md"
                >
                  {group.map((product, index) => (
                    <Link
                      key={index}
                      className="flex gap-3 items-center hover:bg-slate-100 p-2 rounded-md transition relative group"
                      to={`/product/details/${product.slug}`}
                    >
                      {product.discount > 0 && (
                        <div className="flex justify-center items-center absolute text-white w-10 h-10 rounded-full bg-green-600 font-semibold text-xs left-2 top-2">
                          {product.discount}%
                        </div>
                      )}
                      <img
                        className="w-24 h-24 object-cover rounded-md"
                        src={product.image}
                        alt={product.name}
                      />
                      <div className="flex flex-col gap-1 text-slate-600 flex-grow">
                        <h2 className="font-medium text-sm truncate">
                          {product.name}
                        </h2>
                        <span
                          className={`text-lg font-bold ${
                            product.discount > 0 ? "text-green-600" : ""
                          }`}
                        >
                          <CurrencyFormat
                            value={
                              product.price -
                              (product.price * product.discount) / 100
                            }
                          />
                        </span>
                        <div className="flex">
                          <Rating ratings={product.rating} />
                        </div>
                      </div>

                      {/* Botones de acción */}
                      <div className="opacity-0 group-hover:opacity-100 transition-opacity flex gap-2 absolute right-4">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            dispatch(remove_wishlist(product._id));
                          }}
                          className="w-8 h-8 flex justify-center items-center bg-slate-200 rounded-full hover:bg-red-500 hover:text-white transition-colors"
                        >
                          <FaRegHeart />
                        </button>
                        <button className="w-8 h-8 flex justify-center items-center bg-slate-200 rounded-full hover:bg-green-500 hover:text-white transition-colors">
                          <RiShoppingCartLine />
                        </button>
                      </div>
                    </Link>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Wishlist;
